import { useCallback } from "react"
import { createModel } from "hox"
import { useSetState } from "ahooks-v2"
import { defaultRange } from "@/constants/constant"

interface IUsePoisState {
  categoryName?: string
  categoryId?: string
  subTagIds?: string[]
  count?: string
  range?: number
  isShow?: boolean
}
function usePois() {
  const [state, set] = useSetState<IUsePoisState>({
    count: "0",
    range: defaultRange,
  })

  const setPoiValue = useCallback(
    (value: IUsePoisState) => {
      set(value)
    },
    [set],
  )

  return { ...state, setPoiValue }
}

export default createModel(usePois)
